import { createAsyncThunk } from "@reduxjs/toolkit";
import { type BatchStock } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getInventory = createAsyncThunk<
  BatchStock[],
  void,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_INVENTORY, async (_, { extra }) => {
  return await extra.batchesRepo.getInventory();
});
